import { isDevMode } from '@angular/core';
import { environment } from '@config/environments/environment';

// Each project have diffrent appId - you only need to change appId at this const.
/// Default appID;
export const APP_ID_FOR_PROJECT = environment.authen.appKey;

// Link support
const { forgotPassword, createNewAccount, verifyAtLogin, canNotLogin } =
  environment.authen.supportLink;
export const LINK_SUPPORT = {
  FORGOT_PASSWORD: forgotPassword,
  POLICY_WHEN_REGISTER: createNewAccount,
  VERIFY_ACCOUNT_AT_LOGIN: verifyAtLogin,
  CAN_NOT_LOGIN: canNotLogin,
};

export const LINK_NAVIGATE_TO_POLICY_WHEN_REGISTER = '';

// 5 lần login failure -> enable capcha
export const LOGIN_COUNT_ERROR_LIMIT_TO_ENABLE_CAPCHA = 5;

// Kích hoạt chức năng đăng nhập bằng facebook;
export const ENABLE_LOGIN_BY_FACEBOOK = isDevMode();
export const LOGIN_FACEBOOK_SECRET_KEY =
  environment.authen.facebookAuthSecretKey;
export const LOGIN_FACEBOOK_OPTIONS = {
  scope:
    'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
  return_scopes: true,
  enable_profile_selector: true,
};

// Kích hoạt chức năng thay đỗi mật khẩu
export const ENABLE_CHANGE_PASSWORD = true;

// Kích hoạt chức năng thay đỗi địa chỉ email
export const ENABLE_CHANGE_EMAIL = isDevMode();

// Kích hoạt chức năng xác minh lần đầu khi đăng nhập
export const ENABLE_VERIFY_AFTER_LOGIN_FIRST_TIME = !isDevMode();

// Kích hoạt chức năng yêu cầu bổ xung thông tin để xử dụng ứng dụng;
export const ENABLE_REQUIRE_UPDATE_INFO = !isDevMode();

export const ENABLE_CHOOSE_ACCOUNT_TYPE = true;
// DEFAULT ACCOUNT TYPE.
export const E_ACCOUNT_TYPE = {
  NHAN_VIEN: 'NHAN_VIEN',
  SINH_VIEN: 'SINH_VIEN',
};

export const ACCOUNT_TYPES = [
  {
    id: E_ACCOUNT_TYPE.NHAN_VIEN,
    key: 'nv',
    displayText: 'auth.component.login.form.staffAccounType',
    enableLanguage: true,
    show: true,
    default: true,
  },
  {
    id: E_ACCOUNT_TYPE.SINH_VIEN,
    key: 'sv',
    displayText: 'auth.component.login.form.studentAccountType',
    enableLanguage: true,
    show: true,
    default: false,
  },
];

export const API_VERSIONs = {
  VERSION_1_0_0: '1.0.0',
  VERSION_2_0_0: '2.0.0',
};

export enum AuthVersion {
  VERSION_1, // Phan quyen cu
  VERSION_2, // phan quyen moi
}

// Storage key.
// WARNING: SHOULD RENAME TO STORAGE_KEYS
export const SESSION_STORAGE_KEYS = {
  // Session storage:
  CALLBACK_URL: '___core_feature.authenticate.access_token_guard.callback_url',
  CURRENT_REQUIREMENT_AFTER_LOGIN:
    '___core_feature.authenticate.require_udpate_auth_info_after_login_first_time',
  LOGIN_ERROR_RECAPTCHA_COUNT:
    '___core_feature.authenticate.login_default.login_error_recaptcha_count',


  // First login
  HAVE_A_VERIFY_LOGIC: '___core_feature.authen.first_login_have_a_verify_logic',

  // Localstorage:
  OLD_ACCESS_TOKEN: '___core_feature.authenticate.old_access_token',
  ACCESS_TOKEN: '___core_feature.authenticate.access_token',
  LIST_ACTION_ACTIVE: '___core_feature.authenticate.list_action_active',
  USER_INFORMATION: '___core_feature.authenticate.user_information',
  REQUIRE_UPDATE_MORE_INFO_AFTER_ENTER_APP:
    '___core_feature.authenticate.require_update_more_info_after_enter_app',

  // Event emiter
  AUTH_EVENT: '___core_feature.authenticate.events',

  // Appkey
  APP_KEY: '___core_feature.authen.appKey',


  // UPGRADE: Api app mobile sso 30/09/2025
  SSO_MOBILE_AUTHORIZATION_CODE: '___core_feature.authen.sso_mobile_authorization_code',
  SSO_WEB_AUTHORIZATION_CODE: '___core_feature.authen.sso_web_authorization_code',
  SSO_WEB_REDIRECT_URI: '___core_feature.authen.sso_web_redirect_uri',
};

// Upgrade login with token
export const URI_APIS_VERSION_1 = {
  LOGIN: '/login',
  LOGIN_BY_TOKEN: '/login-token',
};

// Apis VERSION 2
export const URI_APIs = {
  LOGIN: `/authen/user/enter-system/login-normal`,
  LOGIN_BY_TOKEN: `/authen/user/enter-system/login-token`,
  LOGIN_BY_THIRD_PARTY: `/authen/user/enter-system/login-th3`,
  GOOGLE_END_ACCESS_TOKEN_ENDPOINT: `/authen/user/enter-system/login-gmail`,
  LOGOUT: `/authen/user/enter-system/logout`,
  REGISTER: '/register',

  // Login 3th
  LOGIN_BY_GOOOGE: '/authen/user/enter-system/login-gmail',
  // Lien ket tai khoan google sau khi dang nhap username password thanh cong
  LINK_GOOGLE_ACCOUNT: '/authen/user/info/link-gmail',
  UN_LINK__GOOGLE_ACCOUNT: '/authen/user/info/unlink-gmail',

  LOGIN_BY_FACEBOOK: 'not-assign',

  // Forgot password
  FORGOT_PASSWORD: '/authen/user/require/forgot-pass/email',
  FORGOT_PASSWORD_HINT_EMAIL: '/authen/user/require/forgot-pass/email/get',
  FORGOT_PASSWORD_SET_NEW_PASSWORD_BY_OTP:
    '/authen/user/require/forgot-pass/set-new-password',
  FORGOT_PASSWORD_CONFIRM_OTP:
    '/authen/user/require/forgot-pass/flow-code/verify',

  // Verify account first login
  VERIFY_FIRST_LOGIN_GET_REQUIRE: '/authen/user/require/get-requirement',

  VERIFY_FIRST_LOGIN_EMAIL_ADDRESS:
    '/authen/user/require/first-login/update-email',

  VERIFY_FIRST_LOGIN_PHONE_NUMBER: '/authen/user/require/first-login/update-phone-number',
  VERIFY_FIRST_LOGIN_GET_HINT_PHONE_NUMBER:
    '/authen/user/enter-system/verify-email',

  VERIFY_FIRST_LOGIN_CHANGE_DEFAULT_PASSWORD:
    '/authen/user/require/first-login/change-password',

  // Api verify otp code dung chung cho tat ca cac nghiep vu dung .
  // TODO: Rename: VERIFY_OTP_CODE
  VERIFY_FIRST_LOGIN_CONFIRM_OTP: '/authen/user/flow-code/verify?code=',

  VERIFY_DEVICE: '/authen/user/require/verify-device',

  // Profile:
  PROFILE_UPDATE: `/authen/user/info/update`,
  PROFILE_GET: '/authen/user/info/get',
  PROFILE_UPDATE_EMAIL: `/authen/user/update-email`,
  PROFILE_CHANGE_PASSWORD: '/authen/user/change-pass',
  PROFILE_UPLOAD_AVATAR: 'profile/upload-avatar',
  PROFILE_UPDATE_PHONE_NUMBER: '/authen/user/update-phone-number',

  // Update info.
  REQUIRE_UPDATE_INFO_GET: '/authen/user/require/get-requirement',
  GET_CONTACT_LOGIN_METHOD: '/authen/user/list-3th-account-linked',

  // File
  UPLOAD_FILE: '/upload',
  DOWNLOAD_FILE: '/download?server_file_name=',
  GET_LIST: '/get-list',

  // UPGRADE: Api app mobile sso 30/09/2025
  // Voi yeu cau mo web tu ung dung gmobiel thi web se dung nhung api nay de goi server psermission
  SSO_MOBILE_LOGIN_NORMAL: '/authen/sso/mobile/login-normal',
  SSO_MOBILE_LOGIN_GMAIL: '/authen/sso/mobile/login-gmail', // off
  //
  // Ung dung mobile goi len sso sidte tryen theo challenge code de sso site goi service auth dang ky phiien dan gnhap
  // Luong web view - goi goi api nay truoc khi goi login form.
  SSO_MOBILE_REGISTER_LOGIN_SESSION: '/authen/sso/mobile/save-code-challenge',

  /// Domain dang nhap & xac minh lan dau luongg dang nhap sso co autheen code
  SSO_LOGIN: `/authen/sso/web/login-normal`,
  // TODO: Chih domain nay neu co thay doi hien trang dang dung cac route xac minh lan cau cua phan user xac minh
  ///
  SSO_LOGIN_BY_TOKEN: `/authen/user/enter-system/login-token`,
  SSO_LOGIN_BY_THIRD_PARTY: `/authen/user/enter-system/login-th3`,
  SSO_GOOGLE_END_ACCESS_TOKEN_ENDPOINT: `/authen/user/enter-system/login-gmail`,
  SSO_VERIFY_FIRST_LOGIN_GET_REQUIRE: '/authen/user/require/get-requirement',
  SSO_VERIFY_FIRST_LOGIN_EMAIL_ADDRESS:
    '/authen/user/require/first-login/update-email',
  SSO_VERIFY_FIRST_LOGIN_PHONE_NUMBER: '/authen/user/require/first-login/update-phone-number',
  SSO_VERIFY_FIRST_LOGIN_GET_HINT_PHONE_NUMBER:
    '/authen/user/enter-system/verify-email',
  SSO_VERIFY_FIRST_LOGIN_CHANGE_DEFAULT_PASSWORD:
    '/authen/user/require/first-login/change-password',
  SSO_VERIFY_FIRST_LOGIN_CONFIRM_OTP: '/authen/user/flow-code/verify?code=',
  SSO_VERIFY_DEVICE: '/authen/user/require/verify-device',

  // Create code authorz cod before redirect
  SSO_GET_AUTHORIZE_CODE: '/authen/sso/web/login-token',
};


export const PUBLIC_ASSET_PATH = 'assets';

// Query param phuc vu cho nhung truyeen cap tu mobile hoac web site ben thu 3 de xac minh thong tin.
// Ben trong cac module va nghiep vu co dung - luu y khi dieu chinh
export const APP_KEY_QUERY_PARAM = 'app_key';
export const LEGACY_APP_KEY_QUERY_PARAM = 'client_id';

export const BACK_LINK_REDIRECT_QUERY_PARAM = 'backlink';
 //login-sso?client_id=MOBILE_HUTECH&backlink=redirect_uri&redirect=/don-phieu/don-phieu-da-nop
export const REDIRECT_QUERY_PARAM = 'redirect';
export const BACK_LINK_REDIRECT_QUERY_PARAM_MOBILE = 'callback';
export const SSO_MOBILE_CODE_CHALLENGE_QUERY_PARAM = 'code_challenge';
export const SSO_WEB_CLIENT_ID_QUERY_PARAM = 'client_id';
export const LOGIN_MOBILE_ROUTE = 'login-mobile';

// Trang hien hiien form dang nhap
// Ben trong cac module va nghiep vu co dung - luu y khi dieu chinh
export const LOGIN_MOBILE_SSO_ROUTE = 'login-mobile-session';
export const IS_MOBILE_BACK_LINK_QUERY_PARAM = 'isMobile';
export const DEFAULT_BACKLINK_REDIRECT_PATTERN = '{domain}?authorization_code={authorization_code}&redirect={path}';
export const DEFAULT_BACKLINK_REDIRECT_PATTERN_WITH_ACCESS_TOKEN = '{domain}?token={token}&redirect={path}';
export const MOBILE_DEFAULT_BACKLINK_REDIRECT_PATTERN = '{domain}?authorization_code={authorization_code}';
export const REDIRECT_DEFAULT_THIRD_PARTY_REDIRECT_PATTERN = '{domain}?authorization_code={authorization_code}&redirect={path}';
export const HTTP_SCHEMA_MOBILE_APP = 'ehutechapp';

// Routes ben trong cac tinh anng implemetn co dudng deu chuyen giua cac page.
export const WEB_SSO_LOGIN_ROUTE = 'login-sso';
export const GOBACK_LOGGIN_PAGE_URL = WEB_SSO_LOGIN_ROUTE;
export const WEB_ROUTE_XAC_MINH_LAN_DAU = 'cap-nhat-thong-tin';
export const WEB_ROUTE_SSO_XAC_MINH_LAN_DAU = 'sso-cap-nhat-thong-tin';

export const REQUEST_AUTHORIZE_CODE_ROUTE = 'yeu-cau-ma-uy-quyen';

// Iput la client id nhan tu url: client_id=10928390182038192398 outpuut la app key
// Dung de truyen vap app key header khi goi request.
export const SSO_CLIENT_ID_APP_KEY_MAP = environment.client_sso;
